import React from 'react';
import PropTypes from 'prop-types';
import { getGtmLink } from './carouselGA';
import { Link } from '~spa/Components/Link/Link';

const SportCarouselIcon = ({
    iconData,
    children,
    source,
    ...otherProps
}) => {
    const { url } = iconData;

    return (
        <Link
            to={url}
            gtmAttribute={getGtmLink(source, url)}
            {...otherProps}>
                {children}
        </Link>
    );
};

SportCarouselIcon.propTypes = {
    children: PropTypes.node.isRequired,
    iconData: PropTypes.object.isRequired,
    source: PropTypes.string.isRequired,
};

export default SportCarouselIcon;
